/* MAVE – collection grid: card reveal, colour swatches, sorting */
(function () {
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function each(l, fn) { Array.prototype.forEach.call(l, fn); }

  function card(c) {
    if (c.__mave) return; c.__mave = true;
    var alt = c.querySelector('.mave-card__img--alt');
    var link = c.querySelector('.mave-card__link');
    var base = link ? link.getAttribute('href') : null;
    var sws = c.querySelectorAll('.mave-sw');
    var picked = null;
    function setAlt(sw) {
      if (!alt) return;
      var src = sw ? sw.getAttribute('data-src') : alt.getAttribute('data-src');
      var set = sw ? sw.getAttribute('data-srcset') : alt.getAttribute('data-srcset');
      if (set && alt.getAttribute('srcset') !== set) { alt.setAttribute('srcset', set); alt.setAttribute('src', src); }
    }
    function show(sw) {
      if (!sw || sw.hasAttribute('data-main') || !alt) { c.classList.remove('show-alt'); return; }
      setAlt(sw); c.classList.add('show-alt');
    }
    each(sws, function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); picked = sw;
        each(sws, function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
        if (link) link.setAttribute('href', sw.getAttribute('data-url') || base);
        show(sw);
      });
      if (canHover) sw.addEventListener('mouseenter', function () { show(sw); });
    });
    if (canHover && alt) {
      c.addEventListener('mouseenter', function () { if (!picked) { setAlt(null); c.classList.add('show-alt'); } });
      c.addEventListener('mouseleave', function () { if (picked) show(picked); else c.classList.remove('show-alt'); });
    }
  }

  function init(scope) {
    each((scope || document).querySelectorAll('[data-mave-grid]'), function (sec) {
      if (sec.__mave) return; sec.__mave = true;
      var cards = sec.querySelectorAll('.mave-card');
      each(cards, card);
      var cols = function () { return window.innerWidth >= 990 ? 4 : window.innerWidth >= 750 ? 3 : 2; };
      if (reduce || !('IntersectionObserver' in window)) {
        each(sec.querySelectorAll('.mave-stagger'), function (el) { el.classList.add('is-in'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
        each(cards, function (c, i) { c.style.setProperty('--d', ((i % cols()) * 0.07).toFixed(2) + 's'); io.observe(c); });
      }
      var sort = sec.querySelector('[data-mave-sort]');
      if (sort) sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
